<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'containerComponents.hubSelection.dialog.selectHub' | translate }}
  </h1>
  <div mat-dialog-content>
    <div [hidden]="noHubsExist()">
      <ui-list-filter
        [filtersConfig]="filterConfig"
        (filtersChange)="fetchListBySearchCriteria($event)"
      ></ui-list-filter>
      <mat-table [dataSource]="dataSource" noDataTableMessage>
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-radio-button class="filter-radio-group" (click)="$event.stopPropagation()" (change)="toggle(row)">
            </mat-radio-button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.name' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ssccId">
          <mat-header-cell *matHeaderCellDef>
            {{ 'administration.hub.field.ssccId' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.ssccId }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggle(row)"></mat-row>
      </mat-table>

      <mat-paginator #paginator> </mat-paginator>
    </div>

    <div *ngIf="noHubsExist() && (hubListFacade.loaded$ | async) && !(loadingFacade.loading$ | async)">
      {{ 'administration.hub.list.noItems' | translate }}
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      [action]="buttonAction.Apply"
      [type]="buttonType.Primary"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>
